
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

// Routes réellement proposées à un sous-utilisateur (currentUser.head) dans
// SideBar.js : accueil, assistant, champs, météo, calendrier, simulations.
// Avant ce garde-fou, PrivateRoute ne vérifiait que le rôle, pas `head` : un
// sous-utilisateur connaissant une URL ROLE_USER pouvait ouvrir n'importe
// quelle page réservée au compte principal (section 11, risque documenté).
const SUB_USER_ALLOWED_PREFIXES = ['/assistant', '/fields', '/weather', '/calendar', '/simulations'];

const isAllowedForSubUser = (pathname) => {
  const lower = pathname.toLowerCase();
  if (lower === '/') return true;
  return SUB_USER_ALLOWED_PREFIXES.some((prefix) => lower.startsWith(prefix));
};

const PrivateRoute = ({ component: Component, user, roles }) => {
  const { pathname } = useLocation();

  if (!user || !roles.includes(user.role)) {
    return <Navigate to="/" />;
  }

  if (user.head && !isAllowedForSubUser(pathname)) {
    return <Navigate to="/" />;
  }

  return Component;
};

export default PrivateRoute;
